/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_LicensedInputs */

const en_field_licensed = /** @type {(inputs: Field_LicensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licensed?`)
};

const es_field_licensed = /** @type {(inputs: Field_LicensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Tiene licencia?`)
};

const fr_field_licensed = /** @type {(inputs: Field_LicensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agréé/Sous licence ?`)
};

const de_field_licensed = /** @type {(inputs: Field_LicensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lizenziert/Zugelassen?`)
};

const ja_field_licensed = /** @type {(inputs: Field_LicensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`資格/免許の有無`)
};

const zh_field_licensed = /** @type {(inputs: Field_LicensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有执照许可？`)
};

const ar_field_licensed = /** @type {(inputs: Field_LicensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل يحمل رخصة؟`)
};

const id_field_licensed = /** @type {(inputs: Field_LicensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berlisensi?`)
};

const it_field_licensed = /** @type {(inputs: Field_LicensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certificato/Con Licenza?`)
};

const ru_field_licensed = /** @type {(inputs: Field_LicensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Есть лицензия?`)
};

const pt_field_licensed = /** @type {(inputs: Field_LicensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licenciado?`)
};

const ko_field_licensed = /** @type {(inputs: Field_LicensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`면허/자격증 소지 여부`)
};

/**
* | output |
* | --- |
* | "Licensed?" |
*
* @param {Field_LicensedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_licensed = /** @type {((inputs?: Field_LicensedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_LicensedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_licensed(inputs)
	if (locale === "es") return es_field_licensed(inputs)
	if (locale === "fr") return fr_field_licensed(inputs)
	if (locale === "de") return de_field_licensed(inputs)
	if (locale === "ja") return ja_field_licensed(inputs)
	if (locale === "zh") return zh_field_licensed(inputs)
	if (locale === "ar") return ar_field_licensed(inputs)
	if (locale === "id") return id_field_licensed(inputs)
	if (locale === "it") return it_field_licensed(inputs)
	if (locale === "ru") return ru_field_licensed(inputs)
	if (locale === "pt") return pt_field_licensed(inputs)
	return ko_field_licensed(inputs)
});